(function(Drupal, $, once){
    Drupal.behaviors.or22 = {
        attach() {
            $(once('or22', 'body')).first().each(function(){
                // Key used to store tutorial state in browser storage
                const localHTBStateKey = 'ukho--htb--prevent-tutorial';
                const startedClass = 'OR22--started';

                // modal selector
                const $modal = $(".OR22 .ME1");
                const $tutorialComponent = $(".OR22");
                const $tutorialCarousel = $(".OR21__carousel");

                window.onload = function () {
                    // Only show tutorial on page load if users haven't previously skipped
                    if (!localStorage.getItem(localHTBStateKey)) {
                        $modal.openModal();
                    }
                }

                $('.OR22__open').click(() => {
                    $tutorialComponent.removeClass(startedClass);
                    $tutorialCarousel.slick('slickGoTo', 0, false);
                    $modal.openModal();
                });

                $('.MO39__start-button').click(() => {
                    $tutorialComponent.addClass(startedClass);
                    $tutorialCarousel.slick('setPosition');
                });

                $('.MO39__skip-button, .OR21__skip-button').click(() => {
                    $modal.closeModal();
                    // Remember the user skipped tutorial
                    localStorage.setItem(localHTBStateKey, "1");
                });
            });
        }
    };
})(Drupal, jQuery, once);
